import styles from "./request.signature.module.css"

import Button from "../../../Components/Button/Button"
import goskey from "../../../images/Goskey.svg"
import CardHeader from "../../../Components/Card/CardHeader"
import RequestFooter from "../../../Components/RequestFooter/RequestFooter"
import SmallCard from "../../../Components/SmallCard/SmallCard"
import { useEffect, useState } from "react"
import React from "react"
import usb from "../../../icons/usb.svg"
import requestIcon from "../../../icons/requestIcon.svg"
import CardContainer from "../../../Components/Card/CardContainer"
import CardBody from "../../../Components/Card/CardBody"
import EmptyBlock from "../../../Components/EmptyBlock/EmptyBlock"
import useRequestContext from "../useRequestContext"
import SignatureModal from "./SignatureModal"
import Badge from "../../../Components/Badge/Badge"
import plusIcon from "../../../icons/PlusCircle.svg"
import RequestAssignment from "./RequestAssignment"

export default function RequestSignature() {

    const { request, deleteDocument, isDisabled, generateStatement, addSignature, sendStatement, setRequest, addDocumentParticipant } = useRequestContext()
    const [isOpen, setOpen] = useState(false)
    const [documents, setDocuments] = useState([])
    const [participant, setParticipant] = useState()
    const [requestFile, setRequestFile] = useState()
    const onUlRepresentingSave = () => {
        const newState = request.Participants.filter(x => x.isActive);
        newState.forEach((x) => {
            addDocumentParticipant(requestFile.Id, x.Id).then()
        })
    }
    const [isRequestAssignment, setRequestAssignment] = useState(false)
    const [nextButton, setNextButton] = useState(<Button text="Статус Росреестра" href={`/request/rosreestr/${request?.Id}`}></Button>)
    useEffect(() => {
        switch (request?.Status.code) {
            case 1:
                setNextButton(<Button text="Сформировать заявления" onClick={() => generateStatement(request?.Id).then(x=>window.location.reload())} />)
                break;
            case 2:
                setNextButton(<Button text="Отправить в Росреестр" onClick={() => sendStatement(request?.Id)} />)
                break;
            case 5:
                setNextButton(<Button text="Посмотреть результаты" href={`/request/rosreestr/${request?.Id}`}></Button>)
                break;

        }
    }, [request?.Status.code])
    const removeDocument = (id) => {
        deleteDocument(id).then(window.location.reload())
    }
    return (<div className={styles.container}>
        {request?.Participants.length === 0 &&
            <CardContainer>
                <CardHeader title="Документы"></CardHeader>
                <CardBody>
                    <EmptyBlock title="Документы на подпись отсуствуют"></EmptyBlock>

                </CardBody>
            </CardContainer>

        }
        {request?.Participants?.map((member) =>
            <CardContainer key={member.Id} >
                {
                    member.UlAgent &&
                    <CardHeader title={member.UlAgent.name} label={member.type} />
                }
                {
                    member.FlSubject &&
                    <CardHeader title={member.FlSubject.name} label={member.type} />
                }
                {
                    member.UlAgentFlSubject &&
                    <CardHeader title={member.UlAgentFlSubject.name} />

                }

                <CardBody>

                    {member.Documents.length > 0 &&
                        <React.Fragment>
                            {
                                member.Documents.map((x) =>
                                    <SmallCard badge={x.Status.code == 1 ? <Badge text="Требует подписания" type="error"></Badge> : <Badge margin text="Подписано" type="success"></Badge>} onRemove={isDisabled ? null : () => removeDocument(x.Id)} key={x.Id} type="default" title={x.FileName} avatar={requestIcon} subtitle={`Тип документа: ${x.DocType.name}`} ></SmallCard>

                                )
                            }
                            {
                                member.Documents.filter(x => x.Status.code === 1).length > 0 &&


                                <React.Fragment>
                                    <span className={styles.subtitle}>Выберите сервис для подписания</span>
                                    <div className={styles.personFooter} >

                                        {/* <Button large onClick={() => setConfirmModal(true)} text="Госключ" icon={goskey} type="primary"></Button> */}
                                        {/* <Button large onClick={() => setConfirmModal(true)} text="Sign Me" type="primary" icon={signMe} ></Button> */}
                                        {/* <Button large onClick={() => setConfirmModal(true)} text="IT Monitoring" icon={atm} type="primary"></Button> */}
                                        <Button large onClick={() => {
                                            setOpen(true);
                                            setDocuments(member.Documents.filter(x => x.Status.code == 1).map((x) => {
                                                return { ...x, isActive: true }
                                            }))
                                            setParticipant(member)
                                        }} text="Токен" type="primary" icon={usb} ></Button>
                                    </div>
                                </React.Fragment>
                            }

                        </React.Fragment>
                    }
                    {
                        member.Documents.length == 0 &&
                        <EmptyBlock title="Нет документов на подпись"></EmptyBlock>
                    }
                </CardBody>

            </CardContainer>

        )}
        {request?.Status.code == 2 &&
            < CardContainer >
                <CardHeader title="Заявления"></CardHeader>
                <CardBody>
                    {request?.Documents.filter(x => x.Category.code == 2).map((x) =>
                        <SmallCard avatar={requestIcon} title={x.FileName} subtitle={x.DocType.name} badge={<Badge type="primary" icon={plusIcon} onClick={() => { setRequestAssignment(true); setRequestFile(x) }} text="Назначить подписанту"></Badge>}></SmallCard>
                    )}
                    {request?.Documents.find(x => x.Category.code == 2) == null &&
                        <React.Fragment>
                            <EmptyBlock title="Нет сформированных заявлений"></EmptyBlock>
                            {/* <Button type="primary" onClick={() => generateStatement(request.Id)} large text="Сформировать заявления"></Button> */}
                        </React.Fragment>
                    }
                </CardBody>
            </CardContainer>

        }

        <RequestAssignment onSave={onUlRepresentingSave} request={request} setRequest={setRequest} requestFile={requestFile} isOpen={isRequestAssignment} setOpen={setRequestAssignment}></RequestAssignment>
        <SignatureModal request={request} setRequest={setRequest} participant={participant} addSignature={addSignature} documents={documents} setDocuments={setDocuments} isOpen={isOpen} setOpen={setOpen}></SignatureModal>
        <RequestFooter back={<Button text="Назад" href={`/request/edit/${request?.Id}`}></Button>} next={nextButton}> </RequestFooter>
    </div >)
}